<template>
  <a
    :href="href"
    target="_blank"
    class="button"
  >
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: 'Button',
  props: {
    href: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  font-size: 20px;
  font-weight: $fw-medium;
  line-height: 1;
  text-align: center;
  color: white;
  border-radius: 27.5px;
  min-width: 226px;
  border: 1px solid white;
  display: inline-block;
  margin-top: 44px;
  padding-top: 15px;
  padding-bottom: 18px;

  &:hover,
  &:visited,
  &:focus,
  &:active {
    color: white;
  }
}
</style>
